const MyApplyComponent = () => import('@/views/user/MyApplyView')

export default [
    {
        path:'/MyApply',
        name:'MyApplyComponent',
        component:MyApplyComponent
    }
]